import React from "react";
import PropTypes from "prop-types";
import { Field, Form } from "react-final-form";
import ValidatedInput from "../../common/ValidatedInput";
import isEmpty from "lodash/isEmpty";

const SuperAdminForm = ({ onSubmit, superAdmin }) => {
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={superAdmin}
      render={({
        submitError,
        handleSubmit,
        form,
        submitting,
        pristine,
        values,
      }) => (
        <form onSubmit={handleSubmit}>
          <div className="container mw-520">
            <h3 className="mb-4">
              {isEmpty(superAdmin) ? `New Super Admin` : "Edit Super Admin"}
            </h3>
            {submitError && (
              <p className="text-left text-error">{submitError} </p>
            )}
            <Field
              label={"Firstname"}
              inputClassName="fin-control"
              name="firstName"
              component={ValidatedInput}
              type="text"
              placeholder="Firstname"
            />
            <Field
              label={"Lastname"}
              inputClassName="fin-control"
              name="lastName"
              component={ValidatedInput}
              type="text"
              placeholder="Lastname"
            />
            <Field
              label={"Email"}
              inputClassName="fin-control"
              name="email"
              component={ValidatedInput}
              type="email"
              placeholder="Email"
            />
            <Field
              label={"Password"}
              inputClassName="fin-control"
              name="password"
              type="text"
              placeholder="Password"
              component={ValidatedInput}
            />
            <div className="mt-45">
              <button
                disabled={submitting || pristine}
                id="submit"
                className="btn btn-sm btn-main"
              >
                {isEmpty(superAdmin)
                  ? `Create Super Admin`
                  : "Update Super Admin"}
              </button>
              <button
                type="button"
                className="btn btn-sm btn-cancel"
                onClick={form.reset}
                disabled={submitting || pristine}
              >
                Reset
              </button>
            </div>
          </div>
        </form>
      )}
    />
  );
};

SuperAdminForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  superAdmin: PropTypes.object,
};

export default SuperAdminForm;
